import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { translate } from '../../../i18n';
import { GameDto } from '../../../models/game/dto/game.dto';
import { GAME_QUERY_KEY } from './useGetGame';

export interface AdminAddUserToGameDto {
    userId: string;
}

export interface AdminAddUserToGameResponse {
    game: GameDto;
    participant: {
        participant: any;
        createdAt: string;
        position: number;
    };
}

export const useAdminAddUserToGame = () => {
    const toast = useToast();
    const queryClient = useQueryClient();
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async ({ gameId, userId }: { gameId: number; userId: string }) => {
            return apiClient.fetchApi<AdminAddUserToGameResponse, AdminAddUserToGameDto>({
                endpoint: `games/${gameId}/admin-add-user`,
                method: 'POST',
                body: { userId },
            });
        },
        onSuccess: (data, { gameId }) => {
            toast({
                title: translate('game.user_added_successfully'),
                description: translate('game.user_has_been_added_to_game'),
                status: 'success',
                duration: 3000,
                isClosable: true,
            });

            queryClient.invalidateQueries({ queryKey: GAME_QUERY_KEY(gameId) });
        },
        onError: (error: any) => {
            toast({
                title: translate('game.error_adding_user'),
                description: error?.message || translate('common.unexpected_error'),
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
        },
    });
};
